import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from 't4core';

@Component({
    selector: 't4-header',
    templateUrl: './viewHeader.html',
    styleUrls: ['./viewHeader.css'],
})
export class ViewHeader extends ComponentBase {
    @Input() icon = "glyphicon-file";
    @Input() title = "";
    @Input() subtitle = "";

    public items = new Array<any>();

    constructor(private route: Router, private activeRoute: ActivatedRoute) {
        super();

        this.rebuildMenu();
    }

    protected authenticationChanged() {
        this.rebuildMenu();
    }

    private rebuildMenu() {
        this.items = new Array<any>();

        for (var i = 0; i < this.route.config.length; i++) {
            if (this.route.config[i].path != this.activeRoute.root.children[0].routeConfig!.path) continue;
            if (this.route.config[i].children == undefined) return;

          for (var j = 0; j < this.route.config[i].children!.length; j++) {
            if (this.route.config[i].children![j].path != this.activeRoute.root.children[0].children[0].routeConfig!.path) continue;
            if (this.route.config[i].children![j].children == undefined) return;

            for (var k = 0; k < this.route.config[i].children[j].children!.length; k++) {
              if (this.route.config[i].children![j].children![k].data == null || this.route.config[i].children![j].children![k].data!["hidden"]) continue;
              var brands = this.route.config[i].children![j].children![k].data!["brands"] != null && this.route.config[i].children![j].children![k].data!["brands"].length > 0 ? this.route.config[i].children![j].children![k].data!["brands"] : null;
              var skipbrands = this.route.config[i].children![j].children![k].data!["skipbrands"] != null && this.route.config[i].children![j].children![k].data!["skipbrands"].length > 0 ? this.route.config[i].children![j].children![k].data!["skipbrands"] : null;
              
              if ((this.route.config[i].children![j].children![k].data!["roles"] != null && !this.Settings.isInAny(this.route.config[i].children![j].children![k].data!["roles"], false, brands, skipbrands)) || !(!this.route.config[i].children![j].data!["requireOneWay"] || this.Settings.clientSettings.IsOneWay)) continue;
              if ((this.route.config[i].children![j].children![k].data!["roles"] != null && !this.Settings.isInAny(this.route.config[i].children![j].children![k].data!["roles"], false, brands, skipbrands)) || !(!this.route.config[i].children![j].data!["requireCampaignEnabled"] || (this.Settings.isInAny(['BusinessManager']) && !this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager']) && this.Settings.clientSettings.PartnerCampaignEnabled) || (this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager'])))) continue;
              if (this.route.config[i].children![j].children![k].data!["requireLanguage"] && this.route.config[i].children![j].children![k].data!["requireLanguage"].indexOf(this.Settings.clientSettings.Language) < 0) continue;

              this.items.push(
                {
                  title: this.route.config[i].children![j].children![k].data!["title"],
                  toolTip: this.route.config[i].children![j].children![k].data!["toolTip"],
                  path: "/" + this.route.config[i].path + "/" + this.route.config[i].children![j].path + '/' + this.route.config[i].children![j].children![k].path,
                  icon: this.route.config[i].children![j].children![k].data!["icon"],
                  color: this.route.config[i].children![j].children![k].data!["color"],
                });
            }
          }
        }
    }
}
